import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  type: z.enum(["database", "blob"]).optional(),
});

export const Route = createFileRoute("/storage-hub/capture-storage/database/$id/")({
  staticData: {
    title: "common.database",
  },
  validateSearch: searchSchema,
});
